export default __webpack_public_path__ + "static/media/EQ200_Logo_wh.1f14e1fb.png";